import React from "react";
import { Link } from "react-router-dom";

/**
 * Brand logo for Privathilfe.ch (transparent PNG)
 * - variant="light" (default) → for any background
 * - variant="dark"            → forces brighter shadow on dark bg (no white card needed because PNG is transparent)
 * - size: sm | md | lg | xl
 */
export default function Logo({ variant = "light", size = "sm", asLink = false, className = "" }) {
    const heights = {
        sm: "h-14 sm:h-16",      // ~56–64px (header / dashboards)
        md: "h-20 sm:h-24",      // ~80–96px (auth panels)
        lg: "h-24 sm:h-32",      // ~96–128px
        xl: "h-32 sm:h-40",      // ~128–160px (hero)
    };
    const heightCls = heights[size] || heights.sm;

    const image = (
        <img
            src="/privathilfe-logo.png"
            alt="Privathilfe.ch — Hand in Hand mit Herzen"
            className={`${heightCls} w-auto select-none object-contain ${variant === "dark" ? "drop-shadow-[0_2px_8px_rgba(255,255,255,0.15)]" : ""}`}
            draggable={false}
        />
    );

    if (asLink) {
        return (
            <Link to="/" className={`inline-flex items-center ${className}`} data-testid="brand-logo-link">
                {image}
            </Link>
        );
    }
    return <span className={`inline-flex items-center ${className}`} data-testid="brand-logo">{image}</span>;
}
